import BulkEditIcon from '@mui/icons-material/Edit';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyBulkCreateGdriveFolder from './EtsyBulkCreateGdriveFolder';

export const etsyBulkCreateGdriveFolder: FeatureObject = {
  type: 'feature',
  title: 'Bulk Create with Gdrive Folder',
  description:
    'Connect your Google Drive, select one or more folder(s), and automatically upload its contents as Etsy listings. Each folder is considered as a listing.',
  IconComponent: BulkEditIcon,
  showFeatureFrontPage: true,
  path: '/etsyBulkCreateGdriveFolder',
  component: (user) => (
    <WithEtsyAccount
      featureName="Bulk Create Listings with Gdrive Folder"
      helpTutorialEnum={HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FOLDER}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyBulkCreateGdriveFolder selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'bulk', 'upload', 'google drive', 'folder'],
};
